import { render, staticRenderFns } from "./prescriptionList.vue?vue&type=template&id=4ab1e79a&"
import script from "./prescriptionList.vue?vue&type=script&lang=js&"
export * from "./prescriptionList.vue?vue&type=script&lang=js&"
import style0 from "./prescriptionList.vue?vue&type=style&index=0&id=4ab1e79a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports